import React, { useEffect, useRef, useState, useCallback } from 'react';
import styles from './ProjectsGallery.module.css';

// Import images statically for the 4 projects
// Project 1: בית עתיק ציורי במושב אבן ספיר
import project1Thumb from '../images/בית עתיק ציורי במושב אבן ספיר 1.jpg';
import project1_2 from '../images/בית עתיק ציורי במושב אבן ספיר 2.jpg';
import project1_3 from '../images/בית עתיק ציורי במושב אבן ספיר 3.jpg';
import project1_4 from '../images/בית עתיק ציורי במושב אבן ספיר 4.jpg';
import project1_5 from '../images/בית עתיק ציורי במושב אבן ספיר 5.jpg';
import project1_6 from '../images/בית עתיק ציורי במושב אבן ספיר 6.jpg';
import project1_7 from '../images/בית עתיק ציורי במושב אבן ספיר 7.jpg';
import project1_8 from '../images/בית עתיק ציורי במושב אבן ספיר 8.jpg';
import project1_9 from '../images/בית עתיק ציורי במושב אבן ספיר 9.jpg';
import project1_10 from '../images/בית עתיק ציורי במושב אבן ספיר 10.jpg';

// Project 2: הפנטהאוז של שי ומיטל
import project2Thumb from '../images/הפנטהאוז של שי ומיטל 1.jpg';
import project2_2 from '../images/הפנטהאוז של שי ומיטל 2.jpg';
import project2_3 from '../images/הפנטהאוז של שי ומיטל 3.jpg';
import project2_4 from '../images/הפנטהאוז של שי ומיטל 4.jpg';
import project2_5 from '../images/הפנטהאוז של שי ומיטל 5.jpg';
import project2_6 from '../images/הפנטהאוז של שי ומיטל 6.jpg';
import project2_7 from '../images/הפנטהאוז של שי ומיטל 7.jpg';
import project2_8 from '../images/הפנטהאוז של שי ומיטל 8.jpg';
import project2_9 from '../images/הפנטהאוז של שי ומיטל 9.jpg';
import project2_10 from '../images/הפנטהאוז של שי ומיטל 10.jpg';
import project2_11 from '../images/הפנטהאוז של שי ומיטל 11.jpg';
import project2_12 from '../images/הפנטהאוז של שי ומיטל 12.jpg';
import project2_13 from '../images/הפנטהאוז של שי ומיטל 13.jpg';
import project2_14 from '../images/הפנטהאוז של שי ומיטל 14.jpg';
import project2_15 from '../images/הפנטהאוז של שי ומיטל 15.jpg';
import project2_16 from '../images/הפנטהאוז של שי ומיטל 16.jpg';
import project2_17 from '../images/הפנטהאוז של שי ומיטל 17.jpg';
import project2_18 from '../images/הפנטהאוז של שי ומיטל 18.jpg';
import project2_19 from '../images/הפנטהאוז של שי ומיטל 19.jpg';
import project2_20 from '../images/הפנטהאוז של שי ומיטל 20.jpg';
import project2_21 from '../images/הפנטהאוז של שי ומיטל 21.jpg';
import project2_22 from '../images/הפנטהאוז של שי ומיטל 22.jpg';
import project2_23 from '../images/הפנטהאוז של שי ומיטל 23.jpg';
import project2_24 from '../images/הפנטהאוז של שי ומיטל 24.jpg';
import project2_25 from '../images/הפנטהאוז של שי ומיטל 25.jpg';
import project2_26 from '../images/הפנטהאוז של שי ומיטל 26.jpg';
import project2_27 from '../images/הפנטהאוז של שי ומיטל 27.jpg';
import project2_28 from '../images/הפנטהאוז של שי ומיטל 28.jpg';
import project2_29 from '../images/הפנטהאוז של שי ומיטל 29.jpg';
import project2_30 from '../images/הפנטהאוז של שי ומיטל 30.jpg';
import project2_31 from '../images/הפנטהאוז של שי ומיטל 31.jpg';
import project2_32 from '../images/הפנטהאוז של שי ומיטל 32.jpg';
import project2_33 from '../images/הפנטהאוז של שי ומיטל 33.jpg';
import project2_34 from '../images/הפנטהאוז של שי ומיטל 34.jpg';
import project2_35 from '../images/הפנטהאוז של שי ומיטל 35.jpg';
import project2_36 from '../images/הפנטהאוז של שי ומיטל 36.jpg';

// Project 3: הבית האקלקטי של הודיה ועוזיה (jpg lowercase based on error)
import project3Thumb from '../images/הבית האקלקטי של הודיה ועוזיה 3.JPG';
import project3_2 from '../images/הבית האקלקטי של הודיה ועוזיה 2.JPG';
import project3_3 from '../images/הבית האקלקטי של הודיה ועוזיה 3.JPG';
import project3_4 from '../images/הבית האקלקטי של הודיה ועוזיה 4.JPG';
import project3_5 from '../images/הבית האקלקטי של הודיה ועוזיה 5.JPG';
import project3_6 from '../images/הבית האקלקטי של הודיה ועוזיה 6.JPG';
import project3_7 from '../images/הבית האקלקטי של הודיה ועוזיה 7.JPG';
import project3_8 from '../images/הבית האקלקטי של הודיה ועוזיה 8.JPG';
import project3_9 from '../images/הבית האקלקטי של הודיה ועוזיה 9.JPG';
import project3_10 from '../images/הבית האקלקטי של הודיה ועוזיה 10.jpg';

// Project 4: הבית של דור ומוריה באורנית
import project4Thumb from '../images/הבית של דור ומוריה באורנית 4.jpg';
import project4_2 from '../images/הבית של דור ומוריה באורנית 2.jpg';
import project4_3 from '../images/הבית של דור ומוריה באורנית 3.jpg';
import project4_4 from '../images/הבית של דור ומוריה באורנית 4.jpg';
import project4_5 from '../images/הבית של דור ומוריה באורנית 5.jpg';
import project4_6 from '../images/הבית של דור ומוריה באורנית 6.jpg';
import project4_7 from '../images/הבית של דור ומוריה באורנית 7.jpg';
import project4_8 from '../images/הבית של דור ומוריה באורנית 8.jpg';
import project4_9 from '../images/הבית של דור ומוריה באורנית 9.jpg';
import project4_10 from '../images/הבית של דור ומוריה באורנית 10.jpg';

// Lazy load images for better performance
const LazyImage = ({ src, alt, className, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '50px' }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {isInView ? (
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          className={`${className} ${isLoaded ? styles.imageLoaded : styles.imageLoading}`}
          onLoad={() => setIsLoaded(true)}
          {...props}
        />
      ) : (
        <div ref={imgRef} className={`${className} ${styles.imagePlaceholder}`} />
      )}
    </>
  );
};

// Projects data
const projects = [
  {
    id: 1,
    title: 'בית עתיק ציורי',
    subtitle: 'מושב אבן ספיר',
    category: 'אוריינטלי',
    imageCount: 34,
    thumbnail: project1Thumb,
    mainImage: project1Thumb,
    gallery: [
      project1Thumb, project1_2, project1_3, project1_4, project1_5,
      project1_6, project1_7, project1_8, project1_9, project1_10
    ],
  },
  {
    id: 2,
    title: 'הפנטהאוז של שי ומיטל',
    subtitle: 'עיצוב פנים מקיף',
    category: 'אקלקטי',
    imageCount: 36,
    thumbnail: project2_13,
    mainImage: project2Thumb,
    gallery: [
      project2Thumb, project2_2, project2_3, project2_4, project2_5,
      project2_6, project2_7, project2_8, project2_9, project2_10,
      project2_11, project2_12, project2_13, project2_14, project2_15,
      project2_16, project2_17, project2_18, project2_19, project2_20,
      project2_21, project2_22, project2_23, project2_24, project2_25,
      project2_26, project2_27, project2_28, project2_29, project2_30,
      project2_31, project2_32, project2_33, project2_34, project2_35,
      project2_36
    ],
  },
  {
    id: 3,
    title: 'הבית האקלקטי',
    subtitle: 'של הודיה ועוזיה',
    category: 'אקלקטי',
    imageCount: 31,
    thumbnail: project3Thumb,
    mainImage: project3Thumb,
    gallery: [
      project3Thumb, project3_2, project3_3, project3_4, project3_5,
      project3_6, project3_7, project3_8, project3_9, project3_10
    ],
  },
  {
    id: 4,
    title: 'הבית של דור ומוריה',
    subtitle: 'אורנית',
    category: 'מודרני עם טוויסט',
    imageCount: 32,
    thumbnail: project4Thumb,
    mainImage: project4Thumb,
    gallery: [
      project4Thumb, project4_2, project4_3, project4_4, project4_5,
      project4_6, project4_7, project4_8, project4_9, project4_10
    ],
  },
];

const ProjectsGallery = () => {
  const sectionRef = useRef(null);
  const modalRef = useRef(null);
  const scrollPositionRef = useRef(0);
  
  const [selectedProject, setSelectedProject] = useState(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open project modal
  const openProject = (project) => {
    scrollPositionRef.current = window.scrollY;
    setSelectedProject(project);
    setCurrentImageIndex(0);
    document.body.style.overflow = 'hidden';
  };

  // Close project modal
  const closeProject = () => {
    document.body.style.overflow = '';
    setSelectedProject(null);
    setIsGalleryOpen(false);
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollPositionRef.current);
    });
  };

  // Open gallery lightbox
  const openGallery = (index = 0) => {
    setCurrentImageIndex(index);
    setIsGalleryOpen(true);
  };

  // Close gallery lightbox
  const closeGallery = () => {
    setIsGalleryOpen(false);
  };

  // Navigate images with useCallback to fix dependency warning
  const nextImage = useCallback(() => {
    if (selectedProject) {
      setCurrentImageIndex((prev) =>
        prev === selectedProject.gallery.length - 1 ? 0 : prev + 1
      );
    }
  }, [selectedProject]);

  const prevImage = useCallback(() => {
    if (selectedProject) {
      setCurrentImageIndex((prev) =>
        prev === 0 ? selectedProject.gallery.length - 1 : prev - 1
      );
    }
  }, [selectedProject]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (isGalleryOpen) {
        if (e.key === 'ArrowRight') prevImage();
        else if (e.key === 'ArrowLeft') nextImage();
        else if (e.key === 'Escape') closeGallery();
      } else if (selectedProject && e.key === 'Escape') {
        closeProject();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isGalleryOpen, selectedProject, nextImage, prevImage]);

  // Reset modal scroll when project changes
  useEffect(() => {
    if (selectedProject && modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }, [selectedProject]);

  return (
    <section ref={sectionRef} className={styles.gallerySection} id="projects">
      <div className={styles.galleryInner}>
        {/* Header */}
        <header className={styles.galleryHeader}>
          <p className={styles.gallerySubtitle}>רגע לפני שנרחיב על הכל..</p>
          <h2 className={styles.galleryTitle}>
            פרויקטים <span className={styles.highlight}>נבחרים</span>
          </h2>
        </header>

        {/* Projects Grid */}
        <div className={styles.projectsGrid}>
          {projects.map((project, index) => (
            <article
              key={project.id}
              className={styles.projectCard}
              onClick={() => openProject(project)}
            >
              {/* Image Container */}
              <div className={styles.imageContainer}>
                <span className={styles.projectNumber}>
                  {String(index + 1).padStart(2, '0')}
                </span>
                
                {/* Flagship Ribbon */}
                <div className={styles.flagshipRibbon}>
                  <span className={styles.ribbonText}>פרויקט הדגל</span>
                </div>
                
                <LazyImage
                  src={project.thumbnail}
                  alt={project.title}
                  className={styles.projectImage}
                />
                
                {/* Overlay */}
                <div className={styles.cardOverlay}>
                  <div className={styles.overlayContent}>
                    <span className={styles.viewProject}>צפייה בפרויקט</span>
                  </div>
                </div>

                {/* Category Badge */}
                <span className={styles.categoryBadge}>{project.category}</span>
              </div>

              {/* Card Content */}
              <div className={styles.cardContent}>
                <div className={styles.cardMeta}>
                  <span className={styles.cardCategory}>{project.category}</span>
                  <span className={styles.metaDivider}></span>
                  <span className={styles.cardArea}>{project.imageCount} תמונות</span>
                </div>
                <h3 className={styles.cardTitle}>{project.title}</h3>
                <p className={styles.cardSubtitle}>{project.subtitle}</p>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* Project Modal */}
      {selectedProject && (
        <div className={styles.modalBackdrop} ref={modalRef}>
          <div className={styles.modal}>
            {/* Close Button */}
            <button className={styles.closeBtn} onClick={closeProject}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>

            {/* Modal Hero */}
            <div className={styles.modalHero}>
              <div className={styles.modalHeroInner}>
                <img
                  src={selectedProject.mainImage}
                  alt={selectedProject.title}
                  className={styles.modalHeroImage}
                />
                <div className={styles.modalHeroOverlay}></div>
                <span className={styles.modalProjectNumber}>
                  {String(projects.findIndex(p => p.id === selectedProject.id) + 1).padStart(2, '0')}
                </span>
              </div>
            </div>

            {/* Modal Content */}
            <div className={styles.modalContent}>
              <div className={styles.modalHeader}>
                <div className={styles.modalMeta}>
                  <span>{selectedProject.category}</span>
                  <span className={styles.modalMetaDot}></span>
                  <span>{selectedProject.imageCount} תמונות</span>
                </div>
                <h2 className={styles.modalTitle}>{selectedProject.title}</h2>
                <p className={styles.modalSubtitle}>{selectedProject.subtitle}</p>
              </div>

              {/* Gallery Grid */}
              <div className={styles.galleryGridSection}>
                <h4 className={styles.gallerySectionTitle}>
                  <span className={styles.galleryTitleLine}></span>
                  גלריית תמונות
                  <span className={styles.galleryTitleLine}></span>
                </h4>
                <div className={styles.modalGallery}>
                  {selectedProject.gallery.map((img, idx) => (
                    <div
                      key={idx}
                      className={styles.galleryThumb}
                      onClick={() => openGallery(idx)}
                    >
                      <div className={styles.galleryThumbInner}>
                        <LazyImage src={img} alt="" className={styles.galleryThumbImage} />
                        <span className={styles.thumbNumber}>{String(idx + 1).padStart(2, '0')}</span>
                        <div className={styles.thumbOverlay}>
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Full Gallery Lightbox */}
      {isGalleryOpen && selectedProject && (
        <div className={styles.galleryOverlay}>
          {/* Close Button */}
          <button className={styles.galleryCloseBtn} onClick={closeGallery}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>

          {/* Main Image Viewer */}
          <div className={styles.galleryViewer}>
            <div className={styles.galleryImageFrame}>
              <img
                src={selectedProject.gallery[currentImageIndex]}
                alt=""
                className={styles.galleryMainImage}
              />
              <span className={styles.galleryImageCounter}>
                {String(currentImageIndex + 1).padStart(2, '0')}
              </span>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button className={`${styles.galleryNavBtn} ${styles.navPrev}`} onClick={prevImage}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
          <button className={`${styles.galleryNavBtn} ${styles.navNext}`} onClick={nextImage}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          {/* Progress */}
          <div className={styles.galleryProgress}>
            <div className={styles.progressTrack}>
              {selectedProject.gallery.map((_, idx) => (
                <div
                  key={idx}
                  className={`${styles.progressDot} ${idx === currentImageIndex ? styles.progressActive : ''}`}
                  onClick={() => setCurrentImageIndex(idx)}
                />
              ))}
            </div>
            <span className={styles.progressCounter}>
              {String(currentImageIndex + 1).padStart(2, '0')} / {String(selectedProject.gallery.length).padStart(2, '0')}
            </span>
          </div>

          {/* Thumbnails Strip */}
          <div className={styles.galleryThumbsStrip}>
            {selectedProject.gallery.map((img, idx) => (
              <div
                key={idx}
                className={`${styles.thumbItem} ${idx === currentImageIndex ? styles.thumbActive : ''}`}
                onClick={() => setCurrentImageIndex(idx)}
              >
                <img src={img} alt="" loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      )}
    
     <div style={{ margin:"0 auto",paddingBottom:20, textAlign:"center", alignItems:"center"
     }}>
          <h2 className={styles.galleryTitle}>
           שירותי <span className={styles.highlight}>הסטודיו</span>
          </h2>
 </div>
    </section>
  );
};

export default ProjectsGallery;